import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listCredits } from "../../actions/creditActions";
import Loader from "../../components/Loader";
import Meta from "../../components/Meta";
import Message from "../../components/Message";
import "./creditsScreen.css";

export default function CreditsScreen() {
  const dispatch = useDispatch();

  const {
    loading,
    error,
    blocks = [],
  } = useSelector((state) => state.creditsList);

  useEffect(() => {
    dispatch(listCredits());
  }, [dispatch]);

  return (
    <main className="credits-editorial">
      <Meta
        title="Costume Production Credits | Academy Costumes London"
        description="View selected costume production and rental credits from Academy Costumes London across film, television, theatre, commercials and related projects."
        image="/images/home/production.jpg"
        url="/credits"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Credits", url: "/credits" },
        ]}
      />

      <header className="credits-editorial__masthead">
        <h1 className="credits-editorial__title">Credits</h1>

        <p className="credits-editorial__standfirst">
          Please see below a small selection of the thousands of varied and
          diverse costume production and rental projects undertaken by Academy
          Costumes London over the past 30 years.
        </p>
      </header>

      {loading ? (
        <div className="credits-editorial__state">
          <Loader />
        </div>
      ) : error ? (
        <div className="credits-editorial__state">
          <Message variant="danger">{error}</Message>
        </div>
      ) : blocks.length === 0 ? (
        <div className="credits-editorial__state">
          <Message>No credits published yet.</Message>
        </div>
      ) : (
        <section className="credits-editorial__stack">
          {blocks.map((block, idx) => {
            const reverse = idx % 2 === 1;

            return (
              <article
                key={block._id || idx}
                className={`credits-editorial__spread${
                  reverse ? " is-reverse" : ""
                }`}
              >
                <div className="credits-editorial__imageCol">
                  {block.image?.url ? (
                    <figure className="credits-editorial__figure">
                      <img
                        className="credits-editorial__image"
                        src={block.image.url}
                        alt={block.image.alt || block.label || "Credits image"}
                        loading="lazy"
                        decoding="async"
                      />
                    </figure>
                  ) : (
                    <div className="credits-editorial__placeholder">
                      Archive image unavailable
                    </div>
                  )}
                </div>

                <div className="credits-editorial__textCol">
                  <div className="credits-editorial__textInner">
                    {block.label ? (
                      <h2 className="credits-editorial__label">
                        {block.label}
                      </h2>
                    ) : null}

                    <ul className="credits-editorial__list">
                      {(block.items || []).map((it, i) => (
                        <li key={i} className="credits-editorial__item">
                          <span className="credits-editorial__itemTitle">
                            {it.title}
                          </span>

                          {it.type ? (
                            <span className="credits-editorial__itemType">
                              {" "}
                              — <em>{it.type}</em>
                            </span>
                          ) : null}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </article>
            );
          })}
        </section>
      )}
    </main>
  );
}
